import {
  Directive,
  Input,
  ElementRef,
  Renderer2,
  OnInit,
  ViewContainerRef,
  ComponentFactoryResolver,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import { MatSpinner } from '@angular/material';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[buttonLoader]'
})
export class ButtonLoaderDirective implements OnInit, OnChanges {

  @Input('buttonLoader') showSpinner: boolean;
  originalInnerText: string;
  spinner: MatSpinner;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver
  ) { }

  ngOnInit() {
    // Record the button's original text
    this.originalInnerText = this.el.nativeElement.innerText;

    // Set the button to maintain the same dimensions, even once we put the spinner inside.
    this.el.nativeElement.style.display = 'flex';
    this.el.nativeElement.style.alignItems = 'center';
    this.el.nativeElement.style.justifyContent = 'center';
    this.el.nativeElement.style.minWidth = '90px';


    // Create the spinner
    const factory = this.componentFactoryResolver.resolveComponentFactory(MatSpinner);
    const componentRef = this.viewContainerRef.createComponent(factory);
    this.spinner = componentRef.instance;

    // Configure the spinner
    // this.spinner.strokeWidth = 3;
    this.spinner.diameter = 18;

    // Hide the spinner
    this.renderer.setStyle(this.spinner._elementRef.nativeElement, 'display', 'none');
    this.renderer.setStyle(this.spinner._elementRef.nativeElement, 'margin-left', '10px');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof (changes.showSpinner) === 'object' && !changes.showSpinner.isFirstChange()) {
      if (changes.showSpinner.currentValue === true) {
        // this.el.nativeElement.style.width = '150px';
        // Clear the button's text
        const span = this.el.nativeElement.querySelector('.mat-button-wrapper') as HTMLSpanElement;
        span.innerText = 'Processando';

        // Append the spinner
        this.renderer.appendChild(this.el.nativeElement, this.spinner._elementRef.nativeElement);

        // Show the spinner
        setTimeout(() => {
          this.renderer.setStyle(this.spinner._elementRef.nativeElement, 'display', 'inline-block');
        }, 230);

      }

      if (changes.showSpinner.currentValue === false) {
        // Hide the spinner
        this.renderer.setStyle(this.spinner._elementRef.nativeElement, 'display', 'none');

        // Remove the spinner
        this.renderer.removeChild(this.el.nativeElement.firstChild, this.spinner._elementRef.nativeElement);
        this.el.nativeElement.style.minWidth = '90px';
        const span = this.el.nativeElement.querySelector('.mat-button-wrapper') as HTMLSpanElement;
        span.innerText = this.originalInnerText;
      }

      this.el.nativeElement.disabled = changes.showSpinner.currentValue;
    }
  }
}
